/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/Booking/Time"
  
}) {
let patientBookingValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'booking',
format: fromHelpers.getAppointmentBookingTime,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient.booking"
 format="helpers.js getAppointmentBookingTime"
 text={patientBookingValueData}
 size="small"
/>
{children}
</React.Fragment>)
}